import { AppModal } from '@beef/elk-common';
import { compose } from '@beef/utils';
import { withOnModalOpenHandler } from '@beef/elk-common/utils';
export var UnlimitedAppModal = compose(withOnModalOpenHandler)(AppModal);